import React from 'react';
import { Container, Stack } from '@mui/material';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';

import { Page } from '../../../../components';
import HeaderBreadcrumbs from '../../../../components/header-breadcrumbs';
import { BannerList } from '../../../../components/lists/banners-list';

const title = 'POM - Banners';
const heading = 'Banners';

export const BannerListScreen: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Page title={title}>
            <Container maxWidth={false}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <HeaderBreadcrumbs
                        heading={heading}
                        links={[
                            {
                                name: 'Manage platform banners',
                                href: '/banners',
                            },
                        ]}
                        activeLast={false}
                    />
                    <Button
                        variant="contained"
                        onClick={() => navigate('/banners/create')}
                    >
                        Create Banner
                    </Button>
                </Stack>
                <BannerList />
            </Container>
        </Page>
    );
};
